<template src="./Data.html"></template>
<style src="./Data.css"></style>

<script>
import moment from "moment";

import store from "@/store";
import Autorizar from "@/components/AcessoRealtec/Autorizar/Autorizar";
import { encerraAcessoRealtec } from "@/services/modules/acessoRealtec.js";

export default {
  components: {
    "app-components-acesso-realtec-autorizar": Autorizar
  },
  data() {
    return {
      dataHeaders: [
        {
          text: "Cliente",
          value: "CLINOME",
          sortable: false
        },
        {
          text: "Requisição",
          value: "ACREALREQUISICAO",
          sortable: false
        },
        {
          text: "IP",
          value: "ACREALORIGEM",
          sortable: false
        },
        {
          text: "Versão",
          value: "ACEREALVERSAOSISTEMA",
          sortable: false
        },
        {
          text: "Máquina",
          value: "ACREALNOMEMAQUINA",
          sortable: false
        },
        {
          text: "Usuário",
          value: "USULOGIN",
          sortable: false
        },
        {
          text: "Autorização",
          value: "ACREALAUTORIZACAO",
          sortable: false
        },
        {
          text: "",
          value: "USUCODIGO",
          sortable: false
        }
      ],
      pagination: { rowsPerPage: 100, sortBy: "ACREALREQUISICAO", descending: true },
      autorizarDialog: false,
      currAcesso: {}
    };
  },
  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    formatAcRealRequisicao(_acRealRequisicao) {
      return moment(_acRealRequisicao).format("DD/MM/YYYY HH:mm");
    },
    formatAcRealAutorizacao(_acRealAutorizacao) {      
      if (moment(_acRealAutorizacao) <= moment("01/01/2010 23:59:59")) return "";

      return moment(_acRealAutorizacao).format("DD/MM/YYYY HH:mm");
    },
    openAutorizarDialog(_currAcesso) {
      if (_currAcesso.ACREALSITUACAO == 0){
        this.currAcesso = _currAcesso;
        this.autorizarDialog = true;
      } else if (_currAcesso.ACREALSITUACAO == 1){
        if (confirm("Deseja encerrar o acesso agora?") == true) {
          encerraAcessoRealtec(_currAcesso.ACREALCONTADOR);
        }
      }      
    },
    closeAutorizarDialog(snackbar) {
      this.autorizarDialog = false;
    }
  },
  computed: {
    isXs() {
      return store.state.window.isXs;
    },
    windowWidth() {
      return store.state.window.width;
    },
    data() {
      return store.state.acessoRealtec.data;
    },
    isLoadingData() {
      return store.state.acessoRealtec.loadingData;
    },
    isLoadingClientes() {
      return store.state.acessoRealtec.loadingClientesData;
    },
    clientes() {
      return store.state.acessoRealtec.clientesData;
    }
  }
};
</script>